import * as fromRouter from '@ngrx/router-store';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Params, Data } from '@angular/router';
import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import * as fromMeta from '../reducers/meta.reducer';
import * as fromNav from '../reducers/nav.reducer';
import * as fromTheme from '../reducers/theme.reducer';

export interface RouterStateUrl {
  url: string;
  queryParams: Params;
  params: Params;
  data: Data;
}

export interface State {
  router: fromRouter.RouterReducerState<RouterStateUrl>;
  meta: fromMeta.MetaState;
  nav: fromNav.NavState;
  theme: fromTheme.ThemeState;
}

export const reducers: ActionReducerMap<State> = {
  router: fromRouter.routerReducer,
  meta: fromMeta.metaDataReducer,
  nav: fromNav.NavReducer,
  theme: fromTheme.ThemeReducer,
};

export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];

export const getRouterState = createFeatureSelector<fromRouter.RouterReducerState<RouterStateUrl>>('router');
export const getNavState = createFeatureSelector<fromNav.NavState>('nav');
export const getThemeState = createFeatureSelector<fromTheme.ThemeState>('theme');

export class CustomSerializer implements fromRouter.RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    const { url } = routerState;
    const { queryParams } = routerState.root;

    let state: ActivatedRouteSnapshot = routerState.root;
    while (state.firstChild) {
      state = state.firstChild;
    }

    const { params } = state;
    const { data } = state;

    return {
      url,
      queryParams,
      params,
      data,
    };
  }
}
